import React, { Fragment } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";


const Offer = () => {



    return (
        <Fragment>
            <Header />
            <div class="breadcumb-wrapper" style={{ background: "linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),  url('/assets/img/added/ban.jpg')" }}>
                <div class="container z-index-common">
                    <div class="breadcumb-content">
                        <h1 class="breadcumb-title">Experiences We Offer</h1>
                        <div class="breadcumb-menu-wrap">
                            <ul class="breadcumb-menu">
                                <li><a href="/">Home</a></li>
                                <li>We Offer</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <div className="space-top space-extra-bottom blog-wrapper1 shape-mockup-wrap">
                <div className="shape-mockup d-none d-xl-block spin z-index-negative" style={{ top: "-5%", left: "-5%" }} >
                    <img src="assets/img/shape/circle1.png" alt="circle" />
                </div>
                <div className="shape-mockup d-none d-xl-block jump z-index-negative" style={{ bottom: "5%", right: "5%" }} >
                    <img src="assets/img/shape/Dot.png" alt="Dots" />
                </div>
                <div className="container">
                    <div className="row justify-content-center text-center">
                        <div className="col-xxl-10 col-12 wow fadeInUp" data-wow-delay="0.3s">
                            <div className="title-area">
                                <span className="sec-subtitle">For travelers seeking purpose and meaning</span>
                                <h2 className="sec-title h1">Find Your Journey</h2>
                                <p>Choose a path that speaks to you. Whether you're called by spirituality, seeking stillness through yoga, or simply want to explore the beauty of India, we offer experiences that are rooted in authenticity and connection.</p>
                            </div>
                        </div>
                    </div>
                    <div className="blog-style4">
                        <div className="blog-image">
                            <img src="assets/img/added/spirituality.jpg" alt="blog" />
                        </div>
                        <div className="blog-content background-image" style={{ backgroundImage : "url('assets/img/shape/blog-bg.png')" }} >
                            <h3 className="blog-title"><a href="/spirituality">Spirituality</a></h3>
                            <p className="blog-text">Discover sacred places and timeless traditions. Our spiritual journeys take you to revered temples, ancient pilgrim trails, and places where devotion and peace flow naturally. Walk in the footsteps of sages and reconnect with your inner self.</p>
                            <a className="vs-btn style4" href="/spirituality">Read More</a>
                        </div>
                    </div>

                    <div className="blog-style4">
                        <div className="blog-image">
                            <img src="assets/img/added/yoga-treat.jpg" alt="blog" />
                        </div>
                        <div className="blog-content background-image" style={{ backgroundImage : "url('assets/img/shape/blog-bg.png')" }}>
                            <h3 className="blog-title"><a href="/yoga">Yoga Retreats</a></h3>
                            <p className="blog-text">These retreats are a chance to slow down, stretch, and clear your head. You`ll practice yoga, try some meditation, eat clean food, and spend time in peaceful places. It`s not about doing everything perfectly it`s just time to feel better in your body and mind.</p>
                            <a className="vs-btn style4" href="/yoga">Read More</a>
                        </div>
                    </div>

                    <div className="blog-style4">
                        <div className="blog-image">
                            <img src="assets/img/added/wellness.jpg" alt="blog" />
                        </div>
                        <div className="blog-content background-image" style={{ backgroundImage : "url('assets/img/shape/blog-bg.png')" }}>
                            <h3 className="blog-title"><a href="/wellness">Wellness</a></h3>
                            <p className="blog-text">Experience India`s healing heritage. From Ayurvedic therapies to organic living, our wellness tours are designed to detox, restore energy, and promote overall wellbeing all guided by trusted local practitioners.</p>
                            <a className="vs-btn style4" href="/wellness">Read More</a>
                        </div>
                    </div>

                    <div className="blog-style4">
                        <div className="blog-image">
                            <img src="assets/img/added/gen-tourism.jpg" alt="blog" />
                        </div>
                        <div className="blog-content background-image" style={{ backgroundImage : "url('assets/img/shape/blog-bg.png')" }}>
                            <h3 className="blog-title"><a href="/tourism">General Tourism</a></h3>
                            <p className="blog-text">Immerse yourself in India`s vibrant culture, cuisine, and landscapes. Whether it's the forts of Rajasthan, the backwaters of Kerala, or bustling city life our tours offer a rich mix of heritage, nature, and modern-day marvels.</p>
                            <a className="vs-btn style4" href="/tourism">Read More</a>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </Fragment>
    );
}

export default Offer;